import React from "react"
import * as Icons from "lucide-react"
import { previewText } from "../utils/emailText"

function initials(name) {
  const parts = (name || "?").trim().split(/\s+/).slice(0, 2)
  return (
    parts
      .map(w => w[0])
      .join("")
      .toUpperCase() || "?"
  )
}

/* Outlook-style desktop "new mail" toast (bottom-right). */
export default function EmailNewMailToast({
  message,
  count,
  onOpen,
  onDelete,
  onFlag,
  onClose,
}) {
  if (!message) return null
  const sender =
    message.from_display ||
    message.from_name ||
    message.from_address ||
    "New message"
  const subject = message.subject || "<no subject>"
  const preview =
    previewText(message.body_text) || previewText(message.body_html)

  return (
    <div className="em-nmt" role="alert">
      <div className="em-nmt-head">
        <span className="em-nmt-brand">
          <span className="em-nmt-logo">O</span>
          Outlook (classic)
          {count > 1 && <span className="em-nmt-count">+{count - 1} more</span>}
        </span>
        <div className="em-nmt-head-actions">
          <button title="More">
            <Icons.MoreHorizontal size={15} />
          </button>
          <button title="Close" onClick={onClose}>
            <Icons.X size={15} />
          </button>
        </div>
      </div>

      <div className="em-nmt-body" onClick={onOpen} title="Open message">
        <span className="em-nmt-avatar">{initials(sender)}</span>
        <div className="em-nmt-text">
          <div className="em-nmt-sender">{sender}</div>
          <div className="em-nmt-subject">{subject}</div>
          <div className="em-nmt-preview">
            {preview || "No preview available"}
          </div>
        </div>
      </div>

      <div className="em-nmt-foot">
        <button title="Delete" onClick={onDelete}>
          <Icons.Trash2 size={17} />
        </button>
        <button title="Flag" onClick={onFlag}>
          <Icons.Flag size={17} />
        </button>
        <button title="Dismiss" onClick={onClose}>
          <Icons.X size={17} />
        </button>
      </div>
    </div>
  )
}
